import {
  RefreshCw,
  Mail,
  AlertCircle,
  AlertTriangle,
  LayoutGrid,
} from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  RefreshCw,
  Mail,
  AlertCircle,
  AlertTriangle,
  LayoutGrid,
};

export const ProblemSection = () => {
  const { problem } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section
      className="py-[90px] lg:py-[110px] bg-[#f0eeea]"
    >
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] max-w-[680px] tracking-[-0.01em]">
          {problem.headline}
        </h2>

        <p className="mt-5 text-[1.05rem] text-stone-500 max-w-[560px]">
          {problem.intro}
        </p>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3.5">
          {problem.painPoints.map((point, index) => {
            const Icon = iconMap[point.icon];
            return (
              <div
                key={index}
                className="flex items-start gap-3.5 p-5 rounded-2xl bg-white/50 backdrop-blur-sm border border-stone-200/40 hover:bg-white/80 hover:shadow-[0_2px_8px_rgba(0,0,0,0.03)]"
                style={{
                  transition: 'background-color 0.3s, box-shadow 0.3s',
                  animationDelay: `${index * 80}ms`,
                }}
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-stone-100/80 flex items-center justify-center mt-0.5">
                  {Icon && <Icon size={16} className="text-stone-400" />}
                </div>
                <p className="text-stone-600 text-[0.9rem] leading-relaxed pt-1">
                  {point.text}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 max-w-[680px]">
          {problem.closing.split('\n\n').map((paragraph, i) => (
            <p key={i} className={`text-[1.05rem] text-stone-700 font-medium leading-[1.7] ${i > 0 ? 'mt-3' : ''}`}>
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
